<!-- Mandatory to have multiple ng-content - keep it in case we need it -->
<ng-template #content><ng-content /></ng-template>


@if (type() !== 'icon') {
  <button
    mat-flat-button
    [disableRipple]="type() === 'line'"
    [matMenuTriggerFor]="matMenuTriggerFor() ?? null"
    class="custom-button"
    [ngClass]="'custom-button_'+type()+' custom-button_'+type()+'_'+subtype()+' custom-button_'+type()+'_'+size()"
    [disabled]="disabled()"
    (click)="!disabled() && clicked.emit()">
    @if (icon() && !iconSuffix()) {
      <mat-icon>{{icon()}}</mat-icon>
    }
    <ng-container *ngTemplateOutlet="content" />
    @if (icon() && iconSuffix()) {
      <mat-icon iconPositionEnd>{{icon()}}</mat-icon>
    }
  </button>
}


@if (type() === 'icon') {
  <button
    mat-flat-button
    [matMenuTriggerFor]="matMenuTriggerFor() ?? null"
    class="custom-button"
    [ngClass]="'custom-button_'+type()+' custom-button_'+type()+'_'+subtype()+' custom-button_'+type()+'_'+size()"
    [disabled]="disabled()"
    (click)="!disabled() && clicked.emit()">
    @if (icon()) {
      <mat-icon>{{icon()}}</mat-icon>
    }
  </button>
}
